orders-planner-warnings
  .alert.alert-warning.icons-alert(if="{ opts.orders_count <= 0 }")
    p
      strong { this.locale().no_orders }
  script(type="typescript").
    this.mixin('orders.planner.warnings');
  style(scoped).
    :scope {
      display: block;
      margin-top: 12px;
      margin-bottom: 12px;
    }
